<template>
  <div class="toast-wrap" :class="{ show: toastVisible }">
    <div class="toast-bar" :class="{ error: toastState === 'error' }">
      <p>{{ toastMessage }}</p>
      <p v-if="toastState === 'error'">관리자에게 문의해주세요.</p>
    </div>
  </div>
</template>


<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'toast-bar',
    computed: mapGetters({
      toastVisible: 'toastVisible',
      toastMessage: 'toastMessage',
      toastState: 'toastState'
    }),
    watch: {
      toastVisible (isVisible) {
        if (isVisible) {
          setTimeout(() => { this.showToastMessage(false) }, 5000)
        }
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @media (max-width: 768px) {
    .toast-bar {
      width: 100% !important;
    }
  }

  .toast-wrap{
    position: fixed;
    bottom: -48px;
    width: 100%;
    height: 48px;

    &.show {
      z-index: 10;
      -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
      -webkit-animation-duration: 1s; /* Safari 4.0 - 8.0 */
      animation-name: toast_show;
      animation-duration: 5s;
    }
  }

  .toast-bar {
    width: 568px;
    height: 48px;
    margin: auto;
    padding: 14px 16px;
    background-color: #343a40;
    border-radius: 2px 2px 0 0;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    text-align: center;
  }

  p {
    margin: 0;
    line-height: 1.29;
    letter-spacing: -0.3px;
    font-weight: bold;
    font-size: 16px;
    color: white;
  }

  .error {
    background-color: #f03e3e !important;
    padding: 7px;
  }

  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes toast_show {
    0%   {bottom:-48px;}
    25%  {bottom:0px;}
    75%  {bottom:0px;}
    100% {bottom:-48px;}
  }

  /* Standard syntax */
  @keyframes toast_show {
    0%   {bottom:-48px;}
    25%  {bottom:0px;}
    75%  {bottom:0px;}
    100% {bottom:-48px;}
  }
</style>



// WEBPACK FOOTER //
// ../common/components/ToastMessage.vue